import { useSession } from '@ltvco/refresh-lib/v1';
import {
  AgentChatDrawer,
  AgentChatLauncher,
  useVehicleFinder,
  useVehicleVetter,
} from '@ltvco/refresh-lib/v2';
import { useCallback, useState } from 'react';

import { useAgentChatVehicle } from 'context/AgentChatVehicleContext';

export const AgentChatSurface = () => {
  const {
    session: { account },
  } = useSession();
  const { vehicle } = useAgentChatVehicle();
  const [chatOpen, setChatOpen] = useState(false);

  const userId = account?.account?.user_info?.user_code ?? '';

  // Hooks are lifted here (not inside the drawer) so the conversation
  // survives open/close cycles.
  const finder = useVehicleFinder(userId);
  const vetter = useVehicleVetter(userId);

  const handleOpenChat = useCallback(() => setChatOpen(true), []);
  const handleCloseChat = useCallback(() => setChatOpen(false), []);

  if (!userId) {
    return null;
  }

  return (
    <>
      <AgentChatLauncher onClick={handleOpenChat} />
      <AgentChatDrawer
        open={chatOpen}
        onClose={handleCloseChat}
        finder={finder}
        vetter={vetter}
        vehicleIdentifier={vehicle?.vehicleIdentifier}
        vehicleTitle={vehicle?.vehicleTitle}
      />
    </>
  );
};
